export default __webpack_public_path__ + "static/media/shopping-bag-1.be133cd6.png";